import { createApi } from '@reduxjs/toolkit/query/react';
import { baseApiQuery } from '../basequery';
import { SearchProjectTypesParams } from '@typings/common';
import { AxiosResponse } from 'axios';
import { ProjectType } from '@typings/project-type';

export interface SearchProjectTypesResult {
  data: ProjectType[];
  total: number;
}

export interface SearchProjectTypesResponse {
  data: SearchProjectTypesResult;
}

export const projectTypesApi = createApi({
  reducerPath: 'projectTypesApi',
  baseQuery: baseApiQuery,
  tagTypes: ['ProjectTypes'],
  endpoints: (builder) => ({
    getProjectTypeByID: builder.query<AxiosResponse<ProjectType>, string>({
      query: (projectTypeID) => ({
        url: `config/project-types/${projectTypeID}`,
        method: 'GET'
      })
    }),
    createProjectType: builder.mutation<AxiosResponse<ProjectType>, Partial<ProjectType>>({
      query: (projectType) => ({
        url: 'config/project-types',
        method: 'POST',
        body: projectType
      }),
      invalidatesTags: ['ProjectTypes']
    }),
    updateProjectType: builder.mutation<
      AxiosResponse<ProjectType>,
      { projectTypeID: string; data: Partial<ProjectType> }
    >({
      query: ({ projectTypeID, data }) => ({
        url: `config/project-types/${projectTypeID}`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ['ProjectTypes']
    }),
    searchProjectTypes: builder.query<SearchProjectTypesResponse, SearchProjectTypesParams | void>({
      query: (params) => ({
        url: 'config/project-types/search',
        method: 'GET',
        params: params ?? undefined
      }),
      providesTags: ['ProjectTypes']
    })
  })
});

export const {
  useSearchProjectTypesQuery,
  useLazySearchProjectTypesQuery,
  useGetProjectTypeByIDQuery,
  useCreateProjectTypeMutation,
  useUpdateProjectTypeMutation
} = projectTypesApi;
